import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort_rating",
  "use": "sort_rating-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"sort_rating\"><g fill-rule=\"evenodd\"><path d=\"M12.25 8 10 2 7.75 8H1l5.4 3.6L4 18l6-4 6 4-2.4-6.4L19 8z\" opacity=\".1\" /><path d=\"M12.25 8 10 2 7.75 8H1l5.4 3.6L4 18l6-4 6 4-2.4-6.4L19 8zM16 9h-4.333L10 4 8.333 9H4l3.846 2.308L6 15.5l4-2.9 4 2.9-1.846-4.192z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol